export default "__VITE_ASSET__aaa6dbc2__"